(function () {
  if (window.themeCartBoot) {
    return;
  }
  window.themeCartBoot = true;

  const bootEl = document.getElementById('CartBoot');
  const urls = bootEl
    ? [
        bootEl.dataset.cartDrawer,
        bootEl.dataset.cartItems,
        bootEl.dataset.inventory,
        bootEl.dataset.quantity,
        bootEl.dataset.notification
      ].filter(Boolean)
    : [];

  let loading = null;
  let ready = false;
  const queued = [];
  const originalPublish =
    window.themePubsub && typeof window.themePubsub.publish === 'function'
      ? window.themePubsub.publish.bind(window.themePubsub)
      : null;

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      if (!src) {
        resolve();
        return;
      }
      if (document.querySelector('script[src="' + src + '"]')) {
        resolve();
        return;
      }
      const script = document.createElement('script');
      script.src = src;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function flushQueue() {
    queued.splice(0).forEach(function (item) {
      if (originalPublish) {
        originalPublish(item.event, item.data);
      }
    });
  }

  function loadCartModules() {
    if (ready) {
      return Promise.resolve();
    }
    if (loading) {
      return loading;
    }
    loading = urls
      .reduce(function (chain, src) {
        return chain.then(function () {
          return loadScript(src);
        });
      }, Promise.resolve())
      .then(function () {
        ready = true;
        flushQueue();
      });
    return loading;
  }

  if (window.themePubsub && originalPublish) {
    window.themePubsub.publish = function (event, data) {
      if (event === 'cart:add-request' && !ready) {
        queued.push({ event: event, data: data });
        loadCartModules();
        return;
      }
      return originalPublish(event, data);
    };
  }

  document.addEventListener(
    'click',
    function (event) {
      const toggle = event.target.closest('[data-cart-toggle]');
      if (!toggle || ready) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      loadCartModules().then(function () {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        } else if (originalPublish) {
          originalPublish('cart:drawer:open-request', {});
        }
      });
    },
    true
  );

  if (document.body && document.body.classList.contains('template-cart')) {
    loadCartModules();
  }
})();
